module.exports = __webpack_public_path__ + "media/application/images/svgs/crop-53324c67707f46bee6d93a837c74b962.svg";